<i18n>
{
    "de": {
      "add_semester": "Neues Semester",
      "current_semester": "Existierende Semester",
      "generate_semester": "Erzeugen"
    },
    "en": {
      "add_semester": "Add Semester",
      "current_semester": "Existing Semesters",
      "generate_semester": "Create"
    }
}
</i18n>

<template>
  <div class="semesters">
    <h1>{{ $t("add_semester") }}</h1>
    <DatePicker
      v-model="semester_start_date"
      ref="semester_start_menu"
      @open="semester_start_menu = true"
      @close="semester_start_menu = false"
      style="border: 1px solid black; border-radius:5px; display:inline-block; margin-bottom: 5px"
    />
    <br>
    <b-button @click="addSemester" variant="primary">{{$t("generate_semester")}}</b-button>

    <br>
    <br>

    <h1>{{ $t("current_semester") }}</h1>
    <Loading :data="[semesters]">
      <b-table :items="semesters" :fields="semester_table_fields">
        <template v-slot:cell(actions)="data">
          <b-button-group>
            <b-button variant="danger" @click="delete_semester(data.item)">
              <font-awesome-icon :icon="['fas', 'trash-alt']"></font-awesome-icon>
              {{ $t('system.semester_delete') }}
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </Loading>
  </div>
</template>

<script>

import SemesterService from '@/api-services/semester.service';
import apiutil from "@/util/apiutil";

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import Loading from "../../components/Loading";

import {EventBus} from '@/eventbus';

export default {
  name: 'tutors',

  components: {
    Loading,
    DatePicker
  },

  computed: {
    console: () => console,
    window: () => window,
  },

  data() {
    return {
      semesters: null,
      semesters_by_id: {},

      semester_start_date: null,
      semester_start_menu: false,

      semester_table_fields: [
        {
          label: this.$t('system.semester_id'),
          key: 'id',
          thStyle: {
              width: "10%"
          }
        },
        {
          label: this.$t('system.semester_start'),
          key: 'starts',
          thStyle: {
              width: "20%"
          }
        },
        {
          label: this.$t('system.actions'),
          key: 'actions',
          thStyle: {
              width: "25%"
          }
        },
      ],
    }
  },

  watch: {
    semester_start_menu (val) {
      val && setTimeout(() => (this.$refs.semester_start_menu.$refs.agenda.mode = 'year'));
    },
  },

  async mounted() {
    this.refresh();
  },

  methods: {
    async refresh() {
      this.semesters = (await SemesterService.getAll()).data.semesters;
      this.semesters_by_id = apiutil.dict_by_value_of_array(this.semesters, 'id');
    },

    async addSemester() {
      if (this.semester_start_date == null) {
        EventBus.$emit('alert', {variant: 'danger', message: this.$t("errors.no_date_selected")})
        return;
      }

      let unix = Math.floor(new Date(this.semester_start_date).getTime() / 1000);
      await SemesterService.addSemester(unix);

      this.semester_start_date = null;
      await this.refresh();
    },

    async delete_semester(semester) {
      console.log(semester.id)
    }
  },

}
</script>
